import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Chantier } from '@/types';

interface ChantierState {
  chantiers: Chantier[];
}

const initialState: ChantierState = {
  chantiers: [],
};

const chantierSlice = createSlice({
  name: 'chantier',
  initialState,
  reducers: {
    setChantiers(state, action: PayloadAction<Chantier[]>) {
      state.chantiers = action.payload;
    },
    addChantier(state, action: PayloadAction<Chantier>) {
      state.chantiers.push(action.payload);
    },
    removeChantier(state, action: PayloadAction<Chantier>) {
      state.chantiers = state.chantiers.filter((c) => c.id !== action.payload.id);
    },
    editChantier(state, action: PayloadAction<Chantier>) {
      const i = state.chantiers.findIndex((c) => c.id === action.payload.id);
      if (i !== -1) state.chantiers[i] = action.payload;
    },
  },
});

export const { setChantiers, addChantier, removeChantier, editChantier } = chantierSlice.actions;
export default chantierSlice.reducer;
